module.exports = __webpack_public_path__ + "img/brain-blue.9dfae378.svg";